module.exports = __webpack_public_path__ + "35147fc82f6ddf96f28ee704acbcc2ca.fbx";